import { chatConstants } from '../constants/chat';

const initialState = {
  url: null,
  msgs: 0,
  unreads: 0,
  online: false,
  name: null,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case chatConstants.SET_CHAT_ROOM_PARAMS_SUCCESS:
      return {
        ...state,
        ...action.params,
      };

    default:
      return state;
  }
};
